/** PIN на устройстве; с рабочим местом — запрос переключения, без него — запрос входа */
export class PinParams {
  pin: string
  workspace?: string

  constructor({ pin, workspace }: { pin: string, workspace?: string }) {
    this.pin = pin
    this.workspace = workspace
  }
}
